import { cn } from "@/lib/utils";
import { focusRing } from "./buttons";
import { AvatarStack } from "@/components/ui/avatar-stack";

interface TeamCardProps {
  id: string;
  name: string;
  nameLabel: string;
  onRename: (name: string) => void;
  memberNames: string[];
  countLabel: string;
  /** "Från avdelning "Kassa"" when the name differs from the raw value. */
  originLabel?: string | null;
  /** "Slås ihop med X" when another card has the same effective name. */
  mergeHint?: string | null;
}

/** One suggested team: avatars, member count and an inline rename. */
export function TeamCard({
  id,
  name,
  nameLabel,
  onRename,
  memberNames,
  countLabel,
  originLabel,
  mergeHint,
}: TeamCardProps) {
  const inputId = `team-name-${id}`;
  return (
    <div
      className={cn(
        "flex flex-col gap-3 rounded-g-lg border bg-g-bg-card p-4 transition-colors",
        mergeHint ? "border-g-primary-muted bg-g-primary-subtle" : "border-g-line",
      )}
      data-testid={`onboarding-team-${id}`}
    >
      <div className="flex items-center justify-between gap-3">
        <AvatarStack names={memberNames} />
        <span className="text-[12.5px] font-semibold text-g-ink-500">{countLabel}</span>
      </div>
      <div className="flex flex-col gap-1">
        <label htmlFor={inputId} className="sr-only">
          {nameLabel}
        </label>
        <input
          id={inputId}
          value={name}
          onChange={(e) => onRename(e.currentTarget.value)}
          className={cn(
            "h-10 w-full rounded-g-sm border border-g-line bg-g-bg-input px-3 text-[15px] font-bold text-g-ink-900 transition-colors hover:border-g-line-strong",
            focusRing,
          )}
        />
        {mergeHint ? (
          <span className="text-[12px] font-medium text-g-primary">{mergeHint}</span>
        ) : originLabel ? (
          <span className="text-[12px] text-g-ink-500">{originLabel}</span>
        ) : null}
      </div>
    </div>
  );
}
